var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3193 15V12.9996C14.3193 11.9388 13.9541 10.9215 13.304 10.1715C12.6538 9.42139 11.7721 9 10.8527 9H4.786C3.86659 9 2.98483 9.42139 2.3347 10.1715C1.68457 10.9215 1.31934 11.9388 1.31934 12.9996V15",
    stroke: "#00B2E3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3193 3.5C10.3193 3.99445 10.1727 4.4778 9.89801 4.88892C9.62331 5.30005 9.23286 5.62048 8.77604 5.8097C8.31923 5.99892 7.81656 6.04843 7.33161 5.95196C6.84666 5.8555 6.4012 5.6174 6.05157 5.26777C5.70194 4.91813 5.46384 4.47268 5.36737 3.98773C5.27091 3.50277 5.32042 3.00011 5.50964 2.54329C5.69886 2.08648 6.01929 1.69603 6.43041 1.42133C6.84153 1.14662 7.32488 1 7.81934 1C8.48238 1 9.11826 1.26339 9.5871 1.73223C10.0559 2.20107 10.3193 2.83696 10.3193 3.5Z",
    stroke: "#00B2E3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.88ea3e8a6ee5966075e42ca2def03788.svg";
export { ForwardRef as ReactComponent };